import React, { useState } from "react";
import { SmallInlineEditable } from "../SmallInlineEditable";
import tags from "./tags.json";
import fuzzysort from "fuzzysort";
import { IoMdClose } from "react-icons/io";
import styles from "./Tag.module.css";
import { TagType } from "../../firebase/firestore";
export type TagProps = {
  adding?: boolean;
  onAdd?: (newTag: string) => Promise<any>;
  value?: string;
  onRemove?: () => Promise<any>;
  otherTags?: TagType[];
  editable?: boolean;
  className?: string;
};

export default function Tag({ adding, onAdd, className, value, onRemove, otherTags, editable, ...rest }: TagProps) {
  const hasOtherTags = otherTags?.length > 0;
  const [suggestions, setSuggestions] = useState([]);
  const updateSuggestions = async (currentInput: string) => {
    let searchRes = await fuzzysort.goAsync(currentInput, tags);
    setSuggestions(
      searchRes
        .filter((res) => !otherTags || otherTags.indexOf(res.target) === -1)
        .slice(0, 3)
        .map((res) => res.target)
    );
  };

  return (
    <div
      {...rest}
      className={styles.tag + " " + className + ` relative text-xs cursor-pointer `}
      onClick={() => !adding && onRemove()}
    >
      {!adding && editable && (
        <IoMdClose
          color={"#cb222a"}
          strokeWidth={22}
          className={styles["close-x"] + `  h-3 w-3 z-20 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2  `}
        />
      )}
      {editable && adding ? (
    <SmallInlineEditable
          tagLook
          xs
          hidePen
          className="text-xs"
          width={80}
          clearAfterSubmit
          submitOnBlur={false}
          editable
          options={suggestions.map((s) => ({ value: s }))}
          onIntermediateUpdate={updateSuggestions}
          placeholder={hasOtherTags ? "+" : "+ add mood"}
          placeholderWidth={hasOtherTags ? 7 : 76}
          value={null}
          setValue={onAdd}
        />
      ) : (
        <div className={styles["tag-content"] + " p-1 bg-bgactive_  rounded-md whitespace-nowrap mx-0.5 px-2"}>
          {value}
        </div>
      )}
    </div>
  );
}
